import type { ReactNode } from "react";

/**
 * Shared form styling. Client forms keep their own state/handlers and use
 * these class constants so every input in the console looks identical.
 */
export const inputClass =
  "mt-1 block w-full rounded-md border border-hairline-strong bg-surface px-3 py-2 text-sm text-ink placeholder:text-faint focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20";

export const selectClass = inputClass;

export const labelClass = "block text-sm font-medium text-ink";

export function Field({
  label,
  htmlFor,
  hint,
  children,
}: {
  label: string;
  htmlFor?: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div>
      <label htmlFor={htmlFor} className={labelClass}>
        {label}
      </label>
      {children}
      {hint ? <p className="mt-1 text-xs text-muted">{hint}</p> : null}
    </div>
  );
}

export function FormError({ children }: { children: ReactNode }) {
  if (!children) return null;
  return (
    <p role="alert" className="rounded-md bg-danger-wash px-3 py-2 text-sm text-danger">
      {children}
    </p>
  );
}
